const twoforty = [
  {
    name: '2g-sim',
    type: '240',
    size: '240px'
  },
  {
    name: '3g-sim',
    type: '240',
    size: '240px'
  },
  {
    name: '4g-sim',
    type: '240',
    size: '240px'
  },
  {
    name: 'calls',
    type: '240',
    size: '240px'
  },
  {
    name: 'connections',
    type: '240',
    size: '240px'
  },
  {
    name: 'data-connectivity',
    type: '240',
    size: '240px'
  },
  {
    name: 'discount-tickets',
    type: '240',
    size: '240px'
  },
  {
    name: 'dnd-activate',
    type: '240',
    size: '240px'
  },
  {
    name: 'dnd-desactivate',
    type: '240',
    size: '240px'
  },
  {
    name: 'ensuring-uninterrupted-services-business',
    type: '240',
    size: '240px'
  },
  {
    name: 'find-rates',
    type: '240',
    size: '240px'
  },
  {
    name: 'international-roaming',
    type: '240',
    size: '240px'
  },
  {
    name: 'internet',
    type: '240',
    size: '240px'
  },
  {
    name: 'iplc',
    type: '240',
    size: '240px'
  },
  {
    name: 'isd',
    type: '240',
    size: '240px'
  },
  {
    name: 'isd-advanced',
    type: '240',
    size: '240px'
  },
  {
    name: 'itfs',
    type: '240',
    size: '240px'
  },
  {
    name: 'maintenance',
    type: '240',
    size: '240px'
  },
  {
    name: 'messages',
    type: '240',
    size: '240px'
  },
  {
    name: 'network-issues',
    type: '240',
    size: '240px'
  },
  {
    name: 'one-more-product',
    type: '240',
    size: '240px'
  },
  {
    name: 'organization',
    type: '240',
    size: '240px'
  },
  {
    name: 'pay-outstanding-invoices',
    type: '240',
    size: '240px'
  },
  {
    name: 'payment-allocated',
    type: '240',
    size: '240px'
  },
  {
    name: 'payment-trends',
    type: '240',
    size: '240px'
  },
  {
    name: 'payment-uncompleted',
    type: '240',
    size: '240px'
  },
  {
    name: 'savings',
    type: '240',
    size: '240px'
  },
  {
    name: 'search-files',
    type: '240',
    size: '240px'
  },
  {
    name: 'secure-browsing',
    type: '240',
    size: '240px'
  },
  {
    name: 'thought-leadership-article-on-ddos',
    type: '240',
    size: '240px'
  },
  {
    name: 'upload-tds',
    type: '240',
    size: '240px'
  },
  {
    name: 'whats-next',
    type: '240',
    size: '240px'
  },
  {
    name: 'write',
    type: '240',
    size: '240px'
  }
];

export default twoforty;


// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/twoforty.js